module.exports = __webpack_public_path__ + "img/1496905958.d0281914.jpg";